export enum SectorType {
  UrbanInfrastructureTool = 1,
  TransportAndRoadRehabilitationTool = 2,
}

export default SectorType;
